const getAbsolutePosition = ({ total, percentage }) => {
  return +(percentage / 100 * total).toFixed(2)
}

export default getAbsolutePosition
